import React from 'react';
import PropTypes from 'prop-types';

import Typography from 'Components/UI/Typography';
import { withStyles } from '@material-ui/core/styles';

function KeyValueVertical({
  prompt, value, valueColor, classes,
}) {
  return (
    <div className={classes.holdingDetailsRow}>
      <div className={classes.keyValuePair}>
        <Typography variant={'body2'} color={'accentBlue2'}>{prompt}</Typography>
        <Typography variant={'body1'} color={valueColor}>{value}</Typography>
      </div>
    </div>
  );
}

KeyValueVertical.propTypes = {
  prompt: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  valueColor: PropTypes.string,
};
KeyValueVertical.defaultProps = {
  valueColor: 'primary',
};

export default withStyles(() => ({
  keyValuePair: {
    display: 'flex',
    flexDirection: 'column',
  },
}))(KeyValueVertical);
